<template>
  <!-- eslint-disable -->
<v-container fluid>
<v-slide-y-transition mode="out-in">
  <div>
    <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
      <h1>Upload Amex Excel File</h1>
      <div class="dropbox">
        <input type="file" name="myFile" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="*" class="input-file">
        <p v-if="isInitial">
        </p>
        <p v-if="isSaving">
          Uploading file...
        </p>
      </div>
    </form>
    <div v-if="items.length > 0">
      <a @click="filtered=false">{{items.length}} </a> rows,
      <a @click="filtered=true">{{items.filter(x => x.Difference != 0).length}}</a> charge discrepancies.
      <v-data-table :mobile-breakpoint="0" disable-pagination hide-default-footer :items="sortedItems" :loading="loading" :headers="headers" v item-key="TrackingNumber"/>
    </div>
  </div>
  </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import invoiceAuditModule, {
  INVOICE_AUDIT_NAMESPACE
} from "./store/invoiceAuditStore";
const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;
export default {
  name: "InvoiceAudit",
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      loading: true,
      filtered: true,
      fileCount: 0,
      currentStatus: null,
      items: [],
      headers: [
        {
          text: "TrackingNumber",
          value: "TrackingNumber",
          align: "left",
          sort: true
        },
        {
          text: "Order Number",
          value: "OrderNumber",
          align: "left",
          sort: true
        },
        {
          text: "Billing Date",
          value: "BillingDate",
          align: "left",
          sort: true
        },
        {
          text: "Courier Invoiced",
          value: "CourierInvoiced",
          align: "left",
          sort: true
        },
        {
          text: "Courier Actual",
          value: "CourierActual",
          align: "left",
          sort: true
        },
        {
          text: "Difference",
          value: "Difference",
          align: "left",
          sort: true
        },
        {
          text: "Invoiced Rows",
          value: "InvoicedRows",
          align: "left",
          sort: true
        },
        {
          text: "Status",
          value: "Status",
          align: "left",
          sort: true
        }
      ]
    };
  },
  computed: {
    sortedItems() {
      if (this.filtered) {
        return this.items.filter(x => x.Difference !== 0);
      }
      return this.items;
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(INVOICE_AUDIT_NAMESPACE, invoiceAuditModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.COURIER_ADMIN]).then(
      res => {
        if (res) {
          this.reset();
        } else this.$goHome();
      }
    );
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.$store
        .dispatch(`${INVOICE_AUDIT_NAMESPACE}/save`, formData)
        .then(response => {
          this.items = response.data;
          this.reset();
          this.loading = false;
        });
    },
    filesChange(fieldName, fileList) {
      this.items = [];
      this.loading = true;
      // handle file changes
      const formData = new FormData();
      /* istanbul ignore else */
      if (!fileList.length) return;
      // append the files to FormData
      /* istanbul ignore next */
      Array.from(Array(fileList.length).keys()).map(x => {
        return formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      /* istanbul ignore next */
      this.save(formData);
    }
  }
};
</script>
